/*
 * Tab wide storage for the sign in flow. Every access is guarded: sessionStorage
 * can be disabled or throw (private mode, blocked site data), and the sign in flow
 * must keep working without it.
 */

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
};

const readItem = (key) => {
  try {
    const storage = getSessionStorage();
    return storage && storage.getItem(key);
  } catch (e) {
    return null;
  }
};

const writeItem = (key, value) => {
  try {
    const storage = getSessionStorage();
    storage && storage.setItem(key, value);
  } catch (e) {
    // storage disabled, the value is just not kept
  }
};

const removeItem = (key) => {
  try {
    const storage = getSessionStorage();
    storage && storage.removeItem(key);
  } catch (e) {
    // nothing to clean up
  }
};

export { readItem, writeItem, removeItem };
